import { N05 } from "./N05";
import { N06 } from "./N06";
import { N07 } from "./N07";
import { N08 } from "./N08";
import { N09 } from "./N09";
import { N10 } from "./N10";
import { N11 } from "./N11";
import { N12 } from "./N12";
import { N13 } from "./N13";

export const CoverageReport = {
  sections: [ 
    N12,
    N11,
    N13,
    N09, 
    // N10,
    N06, 
    N07, 
    N08, 
    N05
  ],
};
